import Switch from '@rio-cloud/rio-uikit/components/switch/Switch';
import isUndefined from 'lodash/fp/isUndefined';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Flags } from 'react-feature-flags';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import {
    selectIsEV,
    selectIsSelectedVehicleEv,
    selectVehicleProfile,
} from '../../store/vehicleProfile/vehicleProfileSelectors';
import { changeIsEV, changeIsProfileSubmited } from '../../store/vehicleProfile/vehicleProfileSlice';

export const VehicleTypeSwitch = () => {
    const dispatch = useAppDispatch();
    const isEV = useAppSelector(selectIsEV).value;
    const isVehicleLocked = useAppSelector(selectVehicleProfile).assetLocked;
    const isSelectedVehicleEv = useAppSelector(selectIsSelectedVehicleEv);

    const [isDisabled, setIsDisabled] = useState<boolean>(false);

    useEffect(() => {
        setIsDisabled(!isUndefined(isVehicleLocked) && !isUndefined(isSelectedVehicleEv));
    }, [isVehicleLocked, isSelectedVehicleEv]);

    const handleVehicleTypeToggle = () => {
        dispatch(changeIsEV(!isEV));
        dispatch(changeIsProfileSubmited(false));
    };

    return (
        <Flags authorizedFlags={['switchEngineType']}>
            <div className='btn-group display-flex' data-testid='vehicle-type-switch'>
                <Switch
                    onChange={handleVehicleTypeToggle}
                    checked={isEV}
                    disabled={isDisabled}
                    labelPosition='left'
                    data-testid='switch-mode'
                >
                    <FormattedMessage id='intl-msg:smartRoute.vehicle.electric.switch' />
                </Switch>
            </div>
        </Flags>
    );
};
